import { Field, FormikErrors } from "formik";
import React from "react";
import ErrorMessage from "../../Tooltips/ErrorMessage";
import { FLKInitialValues } from "../../../../store/onboarding/types";


interface Validation {
    type: string;
    params: [string];
}

interface AllData {
    validate?: boolean;
    subtype?: "text" | "email" | "number" | "iframe";
    type?: "text" | "number" | "iframe";
    value?: string | number;
    validations?: Validation[];
    disabled?: boolean;
}

interface DynamicInputProps {
    name: string;
    label?: string;
    type?: string;
    className?: string;
    allData?: AllData;
    completedPage?: boolean;
    error?: FormikErrors<FLKInitialValues>;
    placeholder?: string;
    [key: string]: any; // For any additional props not able to define here
}

const DynamicInput: React.FC<DynamicInputProps> = (props) => {
    const { name, label, type, className, allData, completedPage, error, placeholder, ...rest } = props;
    const errorMessage = error ? error[`${name}`] || "" : "";
    
    const fieldValidation = (value: string | number | null | undefined) => {
        let error: string | undefined;
        if (allData?.validate) {
            if (allData.subtype === "text" || allData.subtype === "email" || allData.subtype === "number") {
                allData?.validations?.forEach((element) => {
                    if (allData.type === "text" && allData.subtype === "text") {
                        if (!allData?.value) {
                            if (element.type === "required") {
                                error = element.params[0];
                            }
                        } else if (!allData?.value && completedPage) {
                            if (element.type === "required") {
                                error = element.params[0];
                            }
                        }
                    }
                    if (allData.type === "text" && allData.subtype === "email") {
                        if (element.type === "required" && !allData?.value ) {
                            error = element.params[0];
                        } else if (!allData?.value && completedPage) {
                            if (element.type === "required") {
                                error = element.params[0];
                            }
                        } else if (element.type === "email" && allData?.value) {
                            // if (!customEmail.test(value)) {
                            //     error = element.params[0];
                            // }
                        }
                    }
                    if (allData.type === "number") {
                        if (!allData?.value ) {
                            if (element.type === "required") {
                                error = element.params[0];
                            }
                        } else if (!allData?.value && completedPage) {
                            if (element.type === "required") {
                                error = element.params[0];
                            }
                        } else {
                            if (allData?.value) {
                                if (element.type === "format") {
                                    // if (!format.test(value)) {
                                    //     error = element.params[0];
                                    // }
                                }
                            }
                        }
                    }
                    if (allData.type === "iframe" && !allData?.value) {
                        if (element.type === "required") {
                            error = element.params[0];
                        }
                    }
                });
            }
        }
        return error;
    };

    return (
        <>
            <div className="class-name">                
                <Field name={name} 
                id={"input-"+name} 
                type={"text"} 
                disabled={allData?.disabled} 
                validate={fieldValidation}
                placeholder={placeholder}
                className={className} {...rest} />
                <ErrorMessage message={errorMessage as string} />
            </div>
        </>
    );
};

export default DynamicInput;